document.addEventListener("DOMContentLoaded", function() {

  var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.documentElement.style.setProperty('--header-height', `${Math.round(document.getElementById('header').clientHeight)}px`);

//subscription banner
document.querySelectorAll('.subscription-banner .subscription-content a.button').forEach(button => {
  button.addEventListener('click', function () {
    if (button.hasAttribute('data-target')) {
      const targetSelector = button.getAttribute('data-target');
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
});

//other subscriotion why
document.querySelectorAll('.subscription-why a').forEach(button => {
  button.addEventListener('click', function () {
    if (button.hasAttribute('data-target')) {
      const targetSelector = button.getAttribute('data-target');
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
});


  //on anchor click
  // document.querySelectorAll('a').forEach(button => {
  //   button.addEventListener('click', function () {
  //     var get_attr = this.getAttribute('href');
  //     if(get_attr){
  //       window.location.href = get_attr;
  //     }
  //   });
  // });

  
  // console.log('hii loaded')
  function products_data(proId){
    // console.log('hii');

    const productJson = window.product_json; // Assuming it's globally available
    
    // Check if productJson exists
    if (!productJson || !Array.isArray(productJson)) {
        console.error("Product JSON is not available or is invalid.");
        return;
    }

    // Find the product matching the proId
    const matchedProduct = productJson.find(product => product.id === proId);

    if (matchedProduct) {
        // set the product title
        const titleElement = document.querySelector(".subs_pro_right_part .sub_pro_title");
        if (titleElement) {
            titleElement.textContent = matchedProduct.title;
        }

        // Update the product images
        const imageContainer = document.querySelector(".subs_pro_img_part");
        if (imageContainer) {
            // Remove old images
            imageContainer.innerHTML = "";

            // Add new images
            matchedProduct.images.forEach(function (image) {
                const imgElement = document.createElement("img");
                imgElement.src = image; // `image` is the URL in your JSON
                imgElement.alt = matchedProduct.title; // Add alt text if needed
                imgElement.classList.add("swiper-slide");
                imageContainer.appendChild(imgElement);
            });

            // Reinitialize Swiper
            if (window.subsSwiper) {
                window.subsSwiper.destroy(true, true); // Destroy the existing Swiper instance
            }

            window.subsSwiper = new Swiper(".swiper-container-left-img", {
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }


      //change reviews
      document.querySelectorAll('.subs_pro_right_part .subs_pro_review .review-overview').forEach(function(priceElement) {
        priceElement.classList.add('hidden');
      });

      const review_html = document.querySelector('.subs_pro_right_part .subs_pro_review .review-overview[data-id="'+proId+'"]');
      if (review_html) {
        review_html.classList.remove('hidden');
      }

      // set the product description
      const descElement = document.querySelector(".subs_pro_right_part .subs_pro_description");
      if (descElement) {
          descElement.innerHTML = matchedProduct.description;
      }


      //set product variants button
      // Replace variant options dynamically
        const priceOptionsContainer = document.querySelector(".subs_pro_right_part .price_options .subs_pro_options");
        let firstButton = null; 
        if (priceOptionsContainer) {
            // Clear existing variant buttons
            priceOptionsContainer.innerHTML = '';
           

            // Add new variant buttons from index 1 (skipping the first one)
            matchedProduct.variants.slice(1).forEach(function(variant, index) {
                const button = document.createElement("button");
                button.type = "button";
                // button.classList.add(index === 0 ? 'active' : ''); // Set the first variant as active
              // console.log(Shopify.formatMoney(variant.price, '${{amount}}'));
              // Shopify.formatMoney(2000, '${{amount}}')
              // console.log('gg',variant.available)

              if(variant.available == false){
                button.setAttribute("data-disabled", "true");
              }
                button.setAttribute("data-id", variant.id);
                button.setAttribute("data-price", Shopify.formatMoney(variant.price, '${{ amount_no_decimals }}'));
                button.setAttribute("data-compare-price",Shopify.formatMoney(variant.compare_at_price, '${{ amount_no_decimals }}'));

                // If there are selling plan allocations, add them
                if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
                    const sellingPlan = variant.selling_plan_allocations[0];
                    button.setAttribute("data-selling-id", sellingPlan.selling_plan_id);
                    button.setAttribute("data-sell-price",Shopify.formatMoney(sellingPlan.price, '${{amount}}'));
                    button.setAttribute("data-sell-compare-price",Shopify.formatMoney(sellingPlan.compare_at_price, '${{ amount_no_decimals }}'));
                }

                // Set the button's inner text to the variant title
                button.innerHTML = variant.title;

                // If there's a selling price, add it to the button
                if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
                    const span = document.createElement("span");
                    span.classList.add("var_selling_price");
                    span.innerText = Shopify.formatMoney(variant.selling_plan_allocations[0].price, '${{amount}}');
                    if (index !== 0) {
                        span.classList.add("hidden");
                    }
                    button.appendChild(span);
                }

                // Append the button to the container
                priceOptionsContainer.appendChild(button);

              // Store the first button outside the loop
              if (!firstButton) {
                firstButton = button;
              }
            });
        }


      //for the plans set
        let variants = matchedProduct.variants.slice(1); // Get variants excluding the first one
        let variant = variants[0];
        let defaultName = '';
        let defaultPlanId = '';
        let sellingPlansHtml = '';


      if(variant){
          if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
              const firstSellingPlan = variant.selling_plan_allocations[0];
              
              // Set default values
              if (!defaultName) {
                  defaultName = firstSellingPlan.selling_plan_name.toLowerCase();
                  // defaultName = 'hii';
                  defaultPlanId = variant.selling_plan_allocations[0].selling_plan_id;
              }

              // Create the HTML for each allocation
            const replaceLabelElement_fre = document.querySelector('.replace-label');
            const first_fre = replaceLabelElement_fre.getAttribute('data-frequency-1-text');
            const second_fre = replaceLabelElement_fre.getAttribute('data-frequency-2-text');
            
              // variant.selling_plan_allocations.forEach(allocation => {
              variant.selling_plan_allocations.forEach((allocation, index) => {
                  sellingPlansHtml += `
                      <p data-id="${allocation.selling_plan_id}" data-price="${Shopify.formatMoney(allocation.price, '{{amount}}')}" data-compare-price="${Shopify.formatMoney(allocation.compare_at_price, '{{amount}}')}">
                          <span class="plan_name">Delivery ${allocation.selling_plan_name.toLowerCase()}  ${allocation === variant.selling_plan_allocations[0] ? '<span class="current-label-tag">(Recommended)</span>' : ''}</span>
                          ${
                            index === 0 
                              ? `<span class="note_text">${first_fre}</span>` 
                              : `<span class="note_text">${second_fre}</span>`
                          }
                      </p>
                  `;
              });
          }
        
        // Now, update the HTML dynamically
        const replaceLabelElement = document.querySelector('.replace-label');
        if (replaceLabelElement) {
            replaceLabelElement.innerHTML = `
                <p class="label" data-selected-plan-id="${defaultPlanId}">
                    <span class="current-label">Delivery ${defaultName} <span class="current-label-tag">(Recommended)</span></span>
                    <span class="arrow">
                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L8 8L15 1" stroke="#FCFBF4" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </span>
                </p>
                <div class="drawer-items nested-drawer-items">
                    ${sellingPlansHtml}
                </div>
            `;
        }
      }

      //call on load function
      onload();
      if (firstButton) {
          firstButton.click();
      }
      
    } else {
        console.error("Product with the given ID not found.");
    }
  }


  //on load slider
   const swiper = new Swiper('.swiper-container-left-img', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: 1, // Adjust for more slides per view
    spaceBetween: 10, // Space between slides
  });

  const swiperContainer = document.querySelector('.text-with-icons__blocks');

  if (swiperContainer instanceof Element) {
    const swiperText = new Swiper(swiperContainer, {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
  } else {
    console.warn('Swiper container .text-with-icons__blocks not found');
  }

  // const swiperText = new Swiper('.text-with-icons__blocks', {
  //   loop: false,
  //   slidesPerView: 1,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 4,
  //     },
  //   },
  // });

  // Add to cart with selected selling plan
  // document.querySelector('.subs_pro_right_part .subs_pro_steps .atc_step .subs_pro_atc').addEventListener('click', function(event) {
  //   event.preventDefault();

  //   // Get the selected variant ID
  //   const variantId = document.querySelector('.subs_pro_right_part .subs_pro_steps .atc_step input[name="id"]').value;
  //   const sellingPlanId = document.querySelector('.subs_pro_right_part .subs_pro_steps .atc_step input[name="selling_plan"]').value;
    
  //   let formData = {
  //    'items': [{
  //     'id': variantId,
  //     'quantity': 1,
  //     'selling_plan': sellingPlanId,
  //     }]
  //   };

  //   // Send the data to the cart
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(formData)
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     console.log('Product added to cart with selling plan:', data);
  //     // Optionally, you can update the cart UI or redirect the user to the cart page
  //    // fetch(window.location.href)
  //    //  .then(response => response.text())
  //    //  .then(htmlContent => {
  //    //    let doc = new DOMParser().parseFromString(htmlContent, "text/html");
  //    //    let cartDrawerElement = doc.querySelector("#mini-cart .overflow-wrapper");
        
  //    //    if (cartDrawerElement) {
  //    //      document.querySelector("#mini-cart .overflow-wrapper").outerHTML = cartDrawerElement.outerHTML;
  //    //    }
        
  //    //    // Uncomment and modify these lines if you need to manipulate other elements as in the jQuery version
  //    //    // document.querySelector('.m-cart-drawer--inner').classList.remove('al-loading-bar', 'loading', 'al-loading-overlay', 'overlay-show');
  //    //    // document.body.classList.add('overflow-hidden');
  //    //    // document.querySelector("cart-drawer.drawer").classList.remove('is-empty');
  //    //    // document.querySelector("cart-drawer.drawer").classList.add('active');
        
  //    //    // sellingDataAddInCard();  // Call the function as needed
  //    //  })
  //    //  .catch(error => {
  //    //    console.error("Error fetching and modifying HTML:", error);
  //    //  });

  //     // fetch('/cart.js')
  //     // .then(response => response.json())
  //     // .then(cart => {
  //     //   // Assuming your theme uses a cart build function
  //     //   // Example: If your theme has a function like buildMiniCart(), call it here.
  //     //   if (window.buildMiniCart) {
  //     //     console.log('hii')
  //     //     window.buildMiniCart(cart.items);  // You may need to adjust the function name depending on your theme
  //     //   }
  //     //    if (window.bindMCevents) {
  //     //      console.log('hh')
  //     //      window.bindMCevents()
  //     //    }

  //     //   // Open the cart drawer
  //     //   const cartDrawer = document.querySelector('.cart-drawer');
  //     //   if (cartDrawer) {
  //     //     cartDrawer.classList.add('open');  // Assuming there's an 'open' class for opening the cart drawer
  //     //   }

  //     //   // Optionally, if you have a custom cart update function, call it here
  //     //   // Example: yourTheme.updateCartUI(cart);

  //     // })
  //     // .catch(error => {
  //     //   console.error('Error refreshing cart:', error);
  //     // });

      
  //   })
  //   .catch(error => {
  //     console.error('Error adding product to cart:', error);
  //   });
  // });

   document.querySelectorAll('.step_trigger_btn').forEach(function(button) {
    button.addEventListener('click', function() {

       const trigger = document.querySelector('.selling_plan_content .replace-label.show .label');
       if(trigger){
         trigger.click();
       }
      
      const dropdown_wrap = this.closest('.step_dropdown_wrap');
      // console.log('hii')
      const dropdown = this.nextElementSibling; // Get the .step_pro_dropdown element
      if (!dropdown) return;
      if (dropdown_wrap.classList.contains('show')) {
        // Hide the dropdown
        dropdown.style.maxHeight = null; // Collapse the height
        // dropdown.classList.remove('show');
        dropdown_wrap.classList.remove('show');
      } else {
        // Show the dropdown
        dropdown.style.maxHeight = dropdown.scrollHeight + "px"; // Expand to content height
        // dropdown.classList.add('show');
        dropdown_wrap.classList.add('show');
      }
    });
  });

  function onload(){
  //step products dropdown open 
  const selling_plan_have = document.querySelector('.subs_pro_right_part .atc_step [name="selling_plan"]');
  if(selling_plan_have){
    var get_id = selling_plan_have.value;
     // Get the current URL
    let currentUrl = window.location.href;
    if (currentUrl.includes('?')) {
      if (currentUrl.includes('selling_plan=')) {
        currentUrl = currentUrl.replace(/(selling_plan=)[^&]*/, `$1${get_id}`);
      } else {
        currentUrl += `&selling_plan=${get_id}`;
      }
    } else {
      currentUrl += `?selling_plan=${get_id}`;
    }
  
    // Update the browser's address bar (optional)
    window.history.replaceState(null, '', currentUrl);
  }
  // Add click event listener to all <li> elements inside .step_pro_dropdown
  document.querySelectorAll(".step_pro_dropdown ul li").forEach(function (li) {
    li.addEventListener("click", function () {
      const btn = this.closest(".step_pro_dropdown").previousElementSibling; // Get the related .step_trigger_btn

      

        const proId = this.getAttribute("data-pro-id");
        if (proId) {
          btn.setAttribute("data-selected-pro-id", proId);
        }
        products_data(proId); 
      
      const siblings = this.closest("ul").querySelectorAll("li");
      siblings.forEach(sibling => {
        sibling.classList.remove("hidden");
      });
      this.classList.add("hidden");

     
      
      // Extract the image, title, and tag from the clicked <li>
      const imgSrc = this.querySelector(".drop_img img")?.getAttribute("src");
      const title = this.querySelector("h5")?.textContent;
      const tagElement = this.querySelector(".tag-pill");

      // Update the .step_trigger_btn
      if (imgSrc) {
        const btnImg = btn.querySelector(".btn_img img");
        if (btnImg) {
          btnImg.setAttribute("src", imgSrc);
        }
      }
      if (title) {
        const btnTitle = btn.querySelector(".btn_title_tag h5");
        if (btnTitle) {
          btnTitle.textContent = title;
        }
      }
      
      if (tagElement) {
        const newTagClass = Array.from(tagElement.classList).filter(cls => cls !== "tag-pill"); // Get additional classes from .tag-pill
        const btnTag = btn.querySelector(".btn_title_tag .tag-pill");

        if (btnTag) {
          // Update the class of the existing .tag-pill in .step_trigger_btn
          btnTag.className = "tag-pill"; // Reset to default "tag-pill"
          btnTag.textContent = tagElement.textContent;
          newTagClass.forEach(cls => btnTag.classList.add(cls));
        } else {
          // Create and append the tag if not present in .step_trigger_btn
          const newTag = document.createElement("span");
          newTag.className = "tag-pill";
          newTag.textContent = tagElement.textContent;
          newTagClass.forEach(cls => newTag.classList.add(cls));
          btn.querySelector(".btn_title_tag").appendChild(newTag);
        }
      } else {
        // Remove the tag-pill from .step_trigger_btn if not present in the clicked <li>
        const btnTag = btn.querySelector(".btn_title_tag .tag-pill");
        if (btnTag) {
          btnTag.remove();
        }
      }

      // Close the dropdown
      const dropdown = this.closest(".step_pro_dropdown");
      const dropdown_wrap = this.closest('.step_dropdown_wrap');
      dropdown.style.maxHeight = null;
      dropdown_wrap.classList.remove("show");
    });
  });

  
  // Handle button clicks in subs_pro_options variant change
  document.querySelectorAll('.subs_pro_options button').forEach(function(button) {
    button.addEventListener('click', function() {

      const get_text = this.textContent;
      if(get_text.includes('20 Patches')){
        const current_plan = document.querySelector('.selling_plan_content .current-label').textContent;
        if(current_plan.includes('2 weeks')){
          // document.querySelector('.selling_plan_content .current-label .current-label-tag').remove();
          document.querySelector('.selling_plan_content .current-label .current-label-tag')?.remove();
        }else{
          const label_tag = document.querySelector('.selling_plan_content .current-label .current-label-tag');
          if(!label_tag){
            var span = document.createElement('span');
            span.className = 'current-label-tag';
            span.textContent = '(Recommended)';
            document.querySelector('.selling_plan_content .current-label').appendChild(span);
          }
        }

        document.querySelectorAll('.selling_plan_content .replace-label .drawer-items p').forEach(function (p) {
            var planTextElement = p.querySelector('.plan_name');
            if (planTextElement) {
                var planText = planTextElement.textContent.trim();
        
                if (planText.includes('2 weeks')) {
                    var currentLabelTag = planTextElement.querySelector('.current-label-tag');
                    if (currentLabelTag) {
                        currentLabelTag.remove();
                    }
                } else {
                    if (!planTextElement.querySelector('.current-label-tag')) {
                        var span = document.createElement('span');
                        span.className = 'current-label-tag';
                        span.textContent = '(Recommended)';
                        planTextElement.appendChild(span);
                    }
                }
            }
        });

      }else{
        const current_plan = document.querySelector('.selling_plan_content .current-label').textContent;
        if(current_plan.includes('4 weeks')){
          // document.querySelector('.selling_plan_content .current-label .current-label-tag').remove();
          document.querySelector('.selling_plan_content .current-label .current-label-tag')?.remove();
        }else{
          const label_tag = document.querySelector('.selling_plan_content .current-label .current-label-tag');
          
          if(!label_tag){
            var span = document.createElement('span');
            span.className = 'current-label-tag';
            span.textContent = '(Recommended)';
            document.querySelector('.selling_plan_content .current-label').appendChild(span);
          }
        }

        document.querySelectorAll('.selling_plan_content .replace-label .drawer-items p').forEach(function (p) {
            var planTextElement = p.querySelector('.plan_name');
            if (planTextElement) {
                var planText = planTextElement.textContent.trim();
        
                if (planText.includes('4 weeks')) {
                    var currentLabelTag = planTextElement.querySelector('.current-label-tag');
                    if (currentLabelTag) {
                        currentLabelTag.remove();
                    }
                } else {
                    if (!planTextElement.querySelector('.current-label-tag')) {
                        var span = document.createElement('span');
                        span.className = 'current-label-tag';
                        span.textContent = '(Recommended)';
                        planTextElement.appendChild(span);
                    }
                }
            }
        });
      }
      // Remove 'active' class from all buttons and add it to the clicked button
      document.querySelectorAll('.subs_pro_options button').forEach(function(btn) {
        btn.classList.remove('active');
      });
      this.classList.add('active');

      // Get data from the clicked button
      const variantId = this.getAttribute('data-id');
      const sellingPlanId = this.getAttribute('data-selling-id');
      const sellingPrice = this.getAttribute('data-sell-price');
      const price = this.getAttribute('data-price');

      // Set the 'id' hidden input field in the atc_step with the selected variant id
      const atcIdInput = document.querySelector('.atc_step input[name="id"]');
      if (atcIdInput) {
        atcIdInput.value = variantId;
      }
      const atcIdbtn = document.querySelector('.atc_step .subs_pro_atc');
      if (atcIdbtn) {
        if (this.hasAttribute('data-disabled')) {
          atcIdbtn.setAttribute('disabled', 'disabled'); // Add 'disabled' attribute
        }else{
          atcIdbtn.removeAttribute('disabled');
        }
        
        atcIdbtn.setAttribute('data-id',variantId);
      }

      // Set the selling plan id in the hidden selling_plan input field in the atc_step
      const atcPlanInput = document.querySelector('.atc_step input[name="selling_plan"]');
      if (atcPlanInput) {
        atcPlanInput.value = sellingPlanId;
      }

      // Get the price elements in the atc_step
      const comparePrices = document.getElementById('compare-prices');
      const discountPrices = document.getElementById('discount-prices');

      // Check if sellingPrice is available and set the correct prices
      if (sellingPrice) {
        // Set selling price in discount-prices and price in compare-prices
        discountPrices.textContent = sellingPrice;
        discountPrices.style.display = 'inline';  // Make sure it's visible
        comparePrices.textContent = price;
        comparePrices.style.display = 'inline'; // Make sure it's visible
      } else {
        // If no selling price, set regular price in discount-prices and hide compare-prices
        discountPrices.textContent = price;
        discountPrices.style.display = 'inline'; // Make sure it's visible
        comparePrices.style.display = 'none'; // Hide compare-prices
      }

       // Remove 'hidden' class from all .var_selling_price elements and hide the clicked one
      document.querySelectorAll('.var_selling_price').forEach(function(priceElement) {
        priceElement.classList.remove('hidden');
      });

      const sellingPriceElement = this.querySelector('.var_selling_price');
      if (sellingPriceElement) {
        sellingPriceElement.classList.add('hidden');
      }

      // Find the li element associated with the clicked button
      const liElement = this.closest('li');

      // Remove 'hidden' class from the clicked li and add 'currently-clicked' class
      if (liElement) {
        liElement.classList.remove('hidden');
        liElement.classList.add('currently-clicked');
      }
    });
  });

    // Plans dropdown click event
    document.querySelectorAll('.subscription-products-part .subs_pro_right_part .selling_plan_content .drawer-items p').forEach(function(element) {
      element.addEventListener('click', function() {
        var get_id = this.getAttribute('data-id');
        this.closest('.selling_plan_content').querySelector('.label').setAttribute('data-selected-plan-id', get_id);
    
        const sellingPlanInput = this.closest('.subs_pro_steps').querySelector('.atc_step input[name="selling_plan"]');
        if (sellingPlanInput) {
          sellingPlanInput.value = get_id;
           // Get the current URL
          let currentUrl = window.location.href;
          if (currentUrl.includes('?')) {
            if (currentUrl.includes('selling_plan=')) {
              currentUrl = currentUrl.replace(/(selling_plan=)[^&]*/, `$1${get_id}`);
            } else {
              currentUrl += `&selling_plan=${get_id}`;
            }
          } else {
            currentUrl += `?selling_plan=${get_id}`;
          }
        
          // Update the browser's address bar (optional)
          window.history.replaceState(null, '', currentUrl);
        }
        
    
        // Update the current label with the text of the selected plan
        const currentLabel = this.closest('.selling_plan_content').querySelector('.label .current-label');
        if (currentLabel) {
          currentLabel.innerHTML = this.querySelector('.plan_name').innerHTML; // Set the clicked plan's text
        }
    
        // Slide up the drawer after selecting a plan
        const drawerItems_wrap = this.closest('.replace-label');
        const drawerItems = this.closest('.drawer-items');
        if (drawerItems) {
          drawerItems.style.maxHeight = null; // Collapse the drawer
          drawerItems_wrap.classList.remove('show');
        }
    
        // Optional: Toggle the arrow icon (rotate it when the dropdown is closed)
        const arrowIcon = this.closest('.selling_plan_content').querySelector('.label .arrow');
        if (arrowIcon) {
          arrowIcon.classList.remove('open'); // Reset arrow rotation
        }
      });
    });


    // document.querySelectorAll('.replace-label .label').forEach(function(button) {
    //   button.addEventListener('click', function() {
    //     const drawerItems = this.nextElementSibling; // Get the .nested-drawer-items element
    //     const arrow = this.querySelector('.arrow'); // Get the arrow element inside the label
    //     if (!drawerItems || !arrow) return; // Ensure both the drawerItems and arrow exist

    //     const drawer_wrap = this.closest('.replace-label');
    //     // Check if the drawer is already expanded
    //     if (drawer_wrap.classList.contains('show')) {
    //       // Slide up (collapse)
    //       drawerItems.style.maxHeight = null;
    //       drawer_wrap.classList.remove('show');
    //       arrow.classList.remove('open');
    //     } else {
    //       // Slide down (expand)
    //       drawerItems.style.maxHeight = drawerItems.scrollHeight + "px"; // Set max-height to the content height
    //       drawer_wrap.classList.add('show');
    //       arrow.classList.add('open');
    //     }
    //   });
    // });
    document.querySelectorAll('.selling_plan_content .replace-label .label').forEach(function (button) {
        button.addEventListener('click', function (event) {
         const trigger = document.querySelector('.step_dropdown_wrap.show .step_trigger_btn');
         if(trigger){
           trigger.click();
         }
          
            event.stopPropagation(); // Prevent closing when clicking inside
    
            const drawerItems = this.nextElementSibling; // Get the .nested-drawer-items element
            const arrow = this.querySelector('.arrow'); // Get the arrow element inside the label
            if (!drawerItems || !arrow) return; // Ensure both the drawerItems and arrow exist
    
            const drawer_wrap = this.closest('.replace-label');
            // Toggle the drawer
            if (drawer_wrap.classList.contains('show')) {
                closeDrawer(drawer_wrap, drawerItems, arrow);
            } else {
                closeAllDrawers(); // Close other open drawers
                openDrawer(drawer_wrap, drawerItems, arrow);
            }
        });
    });
    
    // // Function to open the drawer
    function openDrawer(drawer_wrap, drawerItems, arrow) {
        drawerItems.style.maxHeight = drawerItems.scrollHeight + "px"; // Set max-height to the content height
        drawer_wrap.classList.add('show');
        arrow.classList.add('open');
    }
    
    // Function to close the drawer
    function closeDrawer(drawer_wrap, drawerItems, arrow) {
        drawerItems.style.maxHeight = null;
        drawer_wrap.classList.remove('show');
        arrow.classList.remove('open');
    }
    
    // // Function to close all open drawers
    function closeAllDrawers() {
        document.querySelectorAll('.replace-label.show').forEach(drawer_wrap => {
            const drawerItems = drawer_wrap.querySelector('.nested-drawer-items');
            const arrow = drawer_wrap.querySelector('.arrow');
            if (drawerItems && arrow) {
                closeDrawer(drawer_wrap, drawerItems, arrow);
            }
        });
    }
    
    // Close when clicking outside
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.replace-label')) {
            closeAllDrawers();

           const drawer_open = document.querySelector('.drawer.replace-label.open');
           if(drawer_open){
             drawer_open.click();
           }
        }

       if (!event.target.closest('.step_dropdown_wrap')) {
         const drawer_open = document.querySelector('.step_dropdown_wrap.show');
         if(drawer_open){
           const trigger = document.querySelector('.step_trigger_btn');
           if(trigger){
             trigger.click();
           }
          }
       }
    });

}

  //call on load function
  onload();


  //on click of variant
  document.querySelectorAll('#dummy-one-time .drawer-items button').forEach(function(button) {
      button.addEventListener('click', function() {
          var varTitle = this.getAttribute('data-var-title');
          var targetButtons = document.querySelectorAll('.skio-group-container.subscription .drawer-items .pseudo-options button'); // Get all target buttons
          var targetButton = document.querySelector('.skio-group-container.subscription .drawer-items .pseudo-options button[data-var-title="' + varTitle + '"]');
  
          if (targetButton) {
              var targetIndex = Array.prototype.indexOf.call(targetButtons, targetButton);
              console.log('Target button index:', targetIndex); // Logs the index of the target button
  
              // Get all spans inside .compare-prices
              var spans = document.querySelectorAll('.skio-group-container.subscription label.inner .skio-price .prices #compare-prices span');
              var spans_2 = document.querySelectorAll('.skio-group-container.subscription label.inner .skio-price .prices #discount-prices span');
              // Remove 'active' class from all spans
              spans.forEach(span => span.classList.remove('active'));
              spans_2.forEach(span => span.classList.remove('active'));
  
              // Add 'active' class to the span at the matched index
              spans.forEach((span, index) => {
                  if (index === targetIndex) {
                      span.classList.add('active');
                      span.style.opacity = "1"; // Set opacity to 1 for the active span
                  } else {
                      span.classList.remove('active');
                      span.style.opacity = "0"; // Set opacity to 0 for the others
                  }
              });
              spans_2.forEach((span, index) => {
                  if (index === targetIndex) {
                      span.classList.add('active');
                      span.style.opacity = "1"; // Set opacity to 1 for the active span
                  } else {
                      span.classList.remove('active');
                      span.style.opacity = "0"; // Set opacity to 0 for the others
                  }
              });
          }
      });
  });

    //on subscription btn
    // Handle button clicks in subs_pro_options variant change
  document.querySelectorAll('.skio-group-container.subscription .pseudo-options button').forEach(function(button) {
    button.addEventListener('click', function() {
      var varTitle = this.getAttribute('data-var-title');
      var targetButton = document.querySelector('.skio-group-container.dummy-one-time .drawer-items button.option[data-var-title="' + varTitle + '"]');
      if(targetButton){
        const var_price = targetButton.getAttribute('data-price');
        const compare_price = targetButton.getAttribute('data-compare-price');

        if(compare_price){
          document.querySelector('.skio-group-container.dummy-one-time').classList.add('compare-price-active');
          document.querySelector('.skio-group-container.dummy-one-time label.inner .skio-price .dummy-compare-price').innerHTML = compare_price;
        }else{
          document.querySelector('.skio-group-container.dummy-one-time').classList.remove('compare-price-active');
        }

        if(var_price){
          document.querySelector('.skio-group-container.dummy-one-time label.inner .skio-price .dummy-full-price').innerHTML = var_price;
        }
      }

      const get_text = this.textContent;
      if(get_text.includes('20 Patches')){
        const current_plan = document.querySelector('.skio-group-container.subscription .drawer-items .current-label').textContent;
        if(current_plan.includes('2 weeks')){
          // document.querySelector('.selling_plan_content .current-label .current-label-tag').remove();
          document.querySelector('.skio-group-container.subscription .drawer-items .current-label .current-label-tag')?.remove();
        }else{
          const label_tag = document.querySelector('.skio-group-container.subscription .drawer-items .current-label .current-label-tag');
          if(!label_tag){
            var span = document.createElement('span');
            span.className = 'current-label-tag';
            span.textContent = '(Recommended)';
            document.querySelector('.skio-group-container.subscription .drawer-items .current-label').appendChild(span);
          }
        }

        document.querySelectorAll('.skio-group-container.subscription .drawer-items .replace-label .drawer-items p').forEach(function (p) {
            var planTextElement = p.querySelector('.plan_name');
            if (planTextElement) {
                var planText = planTextElement.textContent.trim();
        
                if (planText.includes('2 weeks')) {
                    var currentLabelTag = planTextElement.querySelector('.current-label-tag');
                    if (currentLabelTag) {
                        currentLabelTag.remove();
                    }
                } else {
                    if (!planTextElement.querySelector('.current-label-tag')) {
                        var span = document.createElement('span');
                        span.className = 'current-label-tag';
                        span.textContent = ' (Recommended)';
                        planTextElement.appendChild(span);
                    }
                }
            }
        });

      }else{
        const current_plan = document.querySelector('.skio-group-container.subscription .drawer-items .current-label').textContent;
        if(current_plan.includes('4 weeks')){
          // document.querySelector('.selling_plan_content .current-label .current-label-tag').remove();
          document.querySelector('.skio-group-container.subscription .drawer-items .current-label .current-label-tag')?.remove();
        }else{
          const label_tag = document.querySelector('.skio-group-container.subscription .drawer-items .current-label .current-label-tag');
          
          if(!label_tag){
            var span = document.createElement('span');
            span.className = 'current-label-tag';
            span.textContent = '(Recommended)';
            document.querySelector('.skio-group-container.subscription .drawer-items .current-label').appendChild(span);
          }
        }

        document.querySelectorAll('.skio-group-container.subscription .drawer-items .replace-label .drawer-items p').forEach(function (p) {
            var planTextElement = p.querySelector('.plan_name');
            if (planTextElement) {
                var planText = planTextElement.textContent.trim();
        
                if (planText.includes('4 weeks')) {
                    var currentLabelTag = planTextElement.querySelector('.current-label-tag');
                    if (currentLabelTag) {
                        currentLabelTag.remove();
                    }
                } else {
                    if (!planTextElement.querySelector('.current-label-tag')) {
                        var span = document.createElement('span');
                        span.className = 'current-label-tag';
                        span.textContent = ' (Recommended)';
                        planTextElement.appendChild(span);
                    }
                }
            }
        });
      }
    });
  });


});